export var isWindowObjectAvailable = function isWindowObjectAvailable() {
  return typeof window !== 'undefined';
};